<template>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="modal fade" id="confirmDelete" ref="confirmDelete" tabindex="-1" role="dialog" aria-labelledby="confirmDeleteLabel" style="display: none;">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
        <h4 class="modal-title"><i class="fa fa-database mr-5"></i>Confirm</h4>
      </div>
      <div class="modal-body">
        Are you sure you would like to delete this event?
      </div>
      <div class="modal-footer">
        <button type="button" id="closeModal" class="btn btn-danger" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'cancel' | translate}}</button>
        <button type="button" id="cancelEvent" @click="prepareForCancel(selectedItem)" class="btn btn-success" data-dismiss="modal"><span class="fa fa-times mr-5"></span>{{'accept' | translate}}</button>
      </div>
    </div>
      </div>
    </div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{title | capitalize}}</h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-6 col-xs-12">
            <div class="box no-shadow no-margin">
              <div class="box-body text-center">
                <span class="info-box-text">{{`${type}_active` | translate}}</span>
                <span class="info-box-number">
                  <template v-if="stats.active > 0">
                    <animate-number from="0" :to="stats.active"  easing="easeOutQuad"></animate-number>
                  </template>
                  <template v-else>{{stats.active}}</template>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-xs-12">
            <div class="box no-shadow no-margin" data-toggle="tooltip" title="" data-original-title="Alle fehlgeschlagenen Events anzeigen">
              <div class="box-body text-center bg-danger-active">
                <span class="info-box-text">{{'failed_events' | translate}}</span>
                <span class="info-box-number"><i class="fa fa-exclamation-triangle mr-5"></i>
                  <template v-if="stats.failed > 0">
                    <animate-number from="0" :to="stats.failed"  easing="easeOutQuad"></animate-number>
                  </template>
                  <template v-else>{{stats.failed}}</template>
                </span>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-3 col-sm-6" v-if="type === 'events'">
            <div class="input-group">
              <input type="text" name="search" v-model="searchId" class="form-control" placeholder="Event ID" @keyup.13.prevent="paginate('','')" @blur="paginate('','')">
                <div class="input-group-btn">
                  <button type="submit" name="submit" class="btn"><i class="fa fa-search"></i></button>
                </div>
            </div>
          </div>
          <div :class="[type === 'events' ? 'col-xs-9' : 'col-xs-12']">
            <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-xs-12">
            <div class="table-responsive no-padding">
              <table class="table no-margin table-hover table-striped monitoring">
                <thead>
                <template v-if="modifier === 'sap'">
                  <tr>
                    <th>{{'order' | translate}} ID</th>
                    <th>Line ID</th>
                    <th>{{'type' | translate}}</th>
                    <th>{{'date' | translate}}</th>
                    <th>Error</th>
                    <th>{{'retry' | translate}}</th>
                  </tr>
                </template>
                <template v-else>
                  <tr v-if="type === 'events'">
                    <th>ID</th>
                    <th>Status</th>
                    <th>Event</th>
                    <th>{{'created' | translate}}</th>
                    <th>{{'update' | translate}}</th>
                    <th>{{'action' | translate}}</th>
                    <th>{{'delete' | translate}}</th>
                  </tr>
                  <tr v-else="">
                    <th>ID</th>
                    <th style="width: 12%">{{'log_level' | translate}}</th>
                    <th>{{'path' | translate}}</th>
                    <th>Status</th>
                    <th>{{'created' | translate}}</th>
                    <th>{{'update' | translate}}</th>
                  </tr>
                </template>
                </thead>
                <tbody>
                  <tr v-for="item in pagination.data">
                    <td>{{item.id}}</td>
                    <td>
                      <span :class="item.status.style"><i :class="item.status.icon"></i>{{item.status.label | translate}}</span><br/>
                    </td>
                    <td>
                      <template v-if="type === 'events'">
                        <a href="#" data-toggle="modal" data-target="#payloadModal" @click="$emit('pop', item)">{{item.payload.displayName || item.payload | orderTitle}}</a>
                      </template>
                      <template v-else>
                        <a href="#" data-toggle="modal" data-target="#payloadModal" @click="$emit('pop', item)">{{item.connection}}</a>
                      </template>
                    </td>
                    <td class="small">{{item.created_at | orderDate}}<br><i class="fa fa-clock-o mr-5"></i>{{item.created_at | orderDate(true)}}</td>
                    <td class="small">{{item.updated_at | orderDate}}<br><i class="fa fa-clock-o mr-5"></i>{{item.updated_at | orderDate(true)}}</td>
                    <td v-if="type === 'events'"><button v-if="item.status.text === 'text-danger'" class="btn btn-info" @click="retryEvent(item)"><i class="fa fa-refresh"></i></button></td>
                    <td v-if="type === 'events'"><button v-if="item.status.text === 'text-danger'" @click="selectedItem = item" class="btn btn-danger" data-toggle="modal" data-target="#confirmDelete"><i class="fa fa-ban"></i></button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['type', 'reload', 'modifier'],
  data () {
    return {
      stats: {
        total: 0,
        success: 0,
        active: 0,
        failed: 0
      },
      searchId: '',
      pagination: {
        total: 0,
        per_page: 25,
        current_page: 1,
        total_pages: 0,
        data: []
      },
      title: this.type === 'cron' ? 'cronjobs' : this.type,
      endpoint: `monitoring/${((this.modifier === 'sap' || this.modifier === 'statistics' || this.modifier === 'erp' || this.modifier === 'mp') ? `${this.modifier}/` : '')}${this.type}`,
      selectedItem: {}
    }
  },
  methods: {
    getEvents () {
      API.get(`${this.endpoint}/stats`, {})
        .then(response => {
          this.stats = response.data
          API.get(this.endpoint, {})
            .then(response => {
              this.pagination = response.data
              this.filterStatus()
            })
          })
        .catch(error => {
          console.log(error)
        })
    },
    retryEvent (item) {
      API.put(`${this.endpoint}/${item.id}/retry`, {})
        .then(response => {
          item.status = {label: 'retry', style: 'label label-warning', icon: 'fa fa-reply mr-5', text: 'text-warning'}
        })
        .catch(error => {
          console.log(error)
        })
    },
    getStatus (status) {
      switch (status) {
        case 'finished':
          return {label: 'info', style: 'label label-success', icon: 'fa fa-check mr-5', text: 'text-success'}
        case 'retried':
          return {label: 'retry', style: 'label label-warning', icon: 'fa fa-reply mr-5', text: 'text-warning'}
        case 'warning':
          return {label: 'deleted', style: 'label label-secondary', icon: 'fa fa-exclamation-triangle mr-5', text: 'text-purple'}
        case 'error':
          return {label: 'error', style: 'label label-danger', icon: 'fa fa-ban mr-5', text: 'text-danger'}
        case 'start':
          return {label: 'start', style: 'label label-info', icon: 'fa fa-info mr-5', text: 'text-info'}
        case 'removed':
          return {label: 'removed', style: 'label label-warning', icon: 'fa fa-trash mr-5', text: 'text-warning'}
        default:
          return {label: 'info', style: 'label label-primary', icon: 'fa fa-gear mr-5', text: 'text-primary'}
      }
    },
    filterStatus () {
      let items = this.pagination.data
      for (let x in items) {
        items[x].status = this.getStatus(items[x].status)
      }
    },
    paginate (type, value) {
      let url = '?preflight=kek'
      if (type === 'page') {
        url += '&page='
        if (value === 'previous') {
          url += (this.pagination.current_page - 1)
        }
        if (value === 'next') {
          url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
        } else if (value !== 'next' && value !== 'previous') {
          url += value
        }
      }
      if (this.type === 'events') {
        let extra = `${this.searchId !== '' ? `/${this.searchId}` : ''}`
        API.get(`${this.endpoint}${extra}${url}`)
          .then(response => {
              this.pagination = response.data
              this.filterStatus()
            })
          .catch(error => {
            console.log(error)
          })
      } else {
        API.get(`${this.endpoint}${url}`)
          .then(response => {
            this.pagination = response.data
            this.filterStatus()
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    prepareForCancel (item) {
      API.put(`${this.endpoint}/${item.id}/release`, {})
        .then(response => {
          if (response) {
            item.status = {label: 'warning', style: 'label label-secondary', icon: 'fa fa-exclamation-triangle mr-5', text: 'text-purple'}
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    showCancelConfirmModal(item) {
      this.selectedItem = item;
      $(this.$refs.confirmDelete).modal('show');
    }
  },
  mounted () {
    API.get(`${this.endpoint}/stats`, {})
      .then(response => {
        this.stats = response.data
        API.get(this.endpoint, {})
          .then(response => {
            this.pagination = response.data
            this.filterStatus()
          })
      })
      .catch(error => {
        console.log(error)
      })
    },
  watch: {
    reload () {
      API.get(`${this.endpoint}/stats`, {})
        .then(response => {
          this.stats = response.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/MonitoringComponent.vue